import { useMemo } from 'react';

import { Calendar } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';
import { StaticDateSpan } from '@mint-lib/tw-components/patterns';
import { cn } from '@mint-lib/tw-utils';
import { Suggestions } from '@mint-sdk/api-recommendations';

type Props = {
  suggestion: Suggestions.SuggestionResponseType;
};

const SuggestionDateSpan = ({ suggestion }: Props) => {
  const timeAgo = useMemo(() => {
    const suggestionDate = {
      [Suggestions.Statuses.REJECTED]: suggestion.decisionTime,
      [Suggestions.Statuses.ACCEPTING]: suggestion.decisionTime,
      [Suggestions.Statuses.ACCEPTED]: suggestion.decisionTime,
      [Suggestions.Statuses.REWORKING]: suggestion.reworkDate,
      [Suggestions.Statuses.ACTIVE]: suggestion.creationDate,
      [Suggestions.Statuses.ERROR]: suggestion.creationDate,
      [Suggestions.Statuses.EXPIRED]: suggestion.creationDate,
    };

    const displayedDate = suggestionDate[suggestion.status];

    if (!displayedDate) {
      return null;
    }

    return <StaticDateSpan date={displayedDate} />;
  }, [suggestion]);

  return (
    <div
      className={cn(
        'flex h-5 flex-row items-center justify-center gap-0.5',
        typographyVariants({ variant: 'caption1', color: 'secondary' }),
      )}
    >
      <Calendar className="size-4 fill-icon-secondary" />

      <div className="flex items-center pt-px">{timeAgo}</div>
    </div>
  );
};

export default SuggestionDateSpan;
